<template>
  <div id="modal" class="modal product_search_modal" v-show="modalShown">
    <div id="product_search_main" v-bind:class="!isHaseko ? {'modal-main' : true, wrapper : true, search_height : true} : {'modal-main' : true, wrapper : true }">
      <div class="cross_btn2" @click="cancel()">
        <span class="css-cancel"></span>
      </div>
      <div class="modal_content_main">
        <div class="title">絞り込み検索</div>
        <section class="save_search_content">
          <div>
            <div>保存名</div>
            <input type="text" v-model="saveName" @blur="onBlurSaveName" @focus="selectedAll">
          </div>
          <div>
            <div>登録日時</div>
            <dd-calendar
              ref="selectedDateStartRef"
              :value="formatDate(dateStart)"
              :clearBtn="true"
              @selectedDate="selectedDateStart"
              @clearedDate="clearedDateStart"
              @blur="onBlurSelectedDateStart"
            />
            <div class="search_content_space">～</div>
            <dd-calendar
              ref="selectedDateEndRef"
              :value="formatDate(dateEnd)"
              :clearBtn="true"
              @selectedDate="selectedDateEnd"
              @clearedDate="clearedDateEnd"
              @blur="onBlurSelectedDateEnd"
            />
          </div>
          <div>
            <div>納品先住所</div>
            <input type="text" v-model="deliAddress" @blur="onBlurAddress" @focus="selectedAll">
          </div>
        </section>
        <!-- <section class="select_category">
          <h3>商品カテゴリ</h3>
          <div>
            <div v-for="(category, index) in categoryList" :key="'cate_' + index">
              <div v-bind:class="{cetegory_item: true, active: isSelCategory(category.id)}" @click="selectCategory(category)">
                <div>
                  <img :src="categoryImgBlack(category.img)" v-if="!isSelCategory(category.id)">
                  <img :src="categoryImgWhite(category.img)" v-else>
                </div>
                <div>{{categoryName(category.name)}}</div>
              </div>
            </div>
          </div>
        </section> -->
        <!-- <section>
          <h3>希望サイズ</h3>
          <div class="search_outline">ご指定いただいた寸法でカスタマイズ可能な商品を表示いたします。</div>
          <div class="storage_size_area">
            <div class="storage_size">
              <div>幅</div>
              <input type="text" v-model.number="paramForm.minWidth" @keypress="validateNumber" @input="paramForm.minWidth=inputRestNumber($event)" @blur="onBlurStorageItemMinW" @focus="selectedAll">
              <div>mm</div>
            </div>
            <div class="storage_size">
              <div>高さ</div>
              <input type="text" v-model.number="paramForm.minHeight" @keypress="validateNumber" @input="paramForm.minHeight=inputRestNumber($event)" @blur="onBlurStorageItemMinH" @focus="selectedAll">
              <div>mm</div>
            </div>
            <div class="storage_size">
              <div>奥行き</div>
              <input type="text" v-model.number="paramForm.minDepth" @keypress="validateNumber" @input="paramForm.minDepth=inputRestNumber($event)" @blur="onBlurStorageItemMinD" @focus="selectedAll">
              <div>mm</div>
            </div>
          </div>
        </section> -->
        <!-- <section class="product_search_maker" v-if="!isHaseko">
          <h3>メーカー</h3>
          <div class="search_outline">指定メーカーの商品を表示いたします。末尾に各社の所在エリアを記載しています。</div>
          <div class="search_maker_area">
            <div class="content_line">
              <input type="checkbox" :id="'maker_axis'" v-model="makerAxis" @change="selectMaker(10000)"/>
              <label :for="'maker_axis'">アクシス株式会社(近畿)</label>
            </div>
            <div class="content_line">
              <input type="checkbox" :id="'maker_tecma'" v-model="makerTecma" @change="selectMaker(10001)"/>
              <label :for="'maker_tecma'">株式会社テクマ(近畿)</label>
            </div>
            <div class="content_line">
              <input type="checkbox" :id="'maker_fm'" v-model="makerFm" @change="selectMaker(27)"/>
              <label :for="'maker_fm'">ファニチャーメーカー株式会社(関東)</label>
            </div>
            <div class="content_line">
              <input type="checkbox" :id="'maker_miura'" v-model="makerMiura" @change="selectMaker(1001)"/>
              <label :for="'maker_miura'">株式会社みうら(中国)</label>
            </div>
            <div class="content_line">
              <input type="checkbox" :id="'maker_domans'" v-model="makerDomans" @change="selectMaker(300)"/>
              <label :for="'maker_domans'">ドゥーマンズ株式会社(関東)</label>
            </div>
          </div>
        </section>
        <section class="product_search_maker" v-else>
          <h3>メーカー</h3>
          <div class="search_outline">指定メーカーの商品を表示いたします。末尾に各社の所在エリアを記載しています。</div>
          <div class="search_maker_area">
            <div class="content_line">
              <input type="checkbox" :id="'maker_fm'" v-model="makerFm" @change="selectMaker(27)"/>
              <label :for="'maker_fm'">ファニチャーメーカー株式会社(関東)</label>
            </div>
            <div class="content_line">
              <input type="checkbox" :id="'maker_domans'" v-model="makerDomans" @change="selectMaker(300)"/>
              <label :for="'maker_domans'">ドゥーマンズ株式会社(関東)</label>
            </div>
          </div>
        </section> -->
      </div>
      <section class="product_search_action"> <!-- 操作 -->
        <div>{{productCnt}}件の商品があります。</div>
        <div class="main_btn act_sub_btn icon_btn" @click="reset()" v-on:mouseover="isOnReset(true)" v-on:mouseleave="isOnReset(false)">
          <div>条件をリセット</div>
        </div>
        <div class="main_btn sel_main_btn icon_btn" @click="search()" v-on:mouseover="isOnSearch(true)" v-on:mouseleave="isOnSearch(false)">
          <!-- <img :src="imgSearch" class="icon"> -->
          <div>検索</div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import * as App from '../../../../../utils/App'
import * as Api from '../../../../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../../../../constants/App'
import * as FormUtil from '../../../../../utils/FormUtil'
import * as Check from '../../../../../utils/Check'
import Calendar from '../../../../../components/common/Calendar'

export default {
  name: 'estimateModal',
  components: {
    'dd-calendar': Calendar
  },
  props: {
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    onCancel: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    },
    showSuccess: {
      type: Function,
      default: function () {}
    },
    isHaseko: {
      type: Boolean,
      default: false
    },
    categoryList: Array
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      newCnt: 0,
      productCnt: 0,
      saveName: undefined,
      dateStart: undefined,
      dateEnd: undefined,
      deliAddress: undefined,
      schedule: {},
      errors: {}
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    showModal: function () {
      this.modalShown = true
      this.searchSaveCnt()
    },
    reset: function () {
      this.saveName = undefined
      this.dateStart = undefined
      this.dateEnd = undefined
      this.deliAddress = undefined
      this.$refs.selectedDateStartRef.cleared()
      this.$refs.selectedDateEndRef.cleared()
      this.searchSaveCnt()
    },
    search: function () {
      if (!this.modalShown) return
      this.errors = {}
      if (Object.keys(this.errors).length !== 0) {
        return false
      }
      this.callbackParams = {
        saveName: this.saveName,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        deliAddress: this.deliAddress
      }
      this.onOk(this.callbackParams)
      this.modalShown = false
    },
    cancel: function () {
      this.onCancel(this.callbackParams)
      this.modalShown = false
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    isOnReset: function () {
    },
    isOnSearch: function () {
    },
    onBlurSaveName: function () {
      if (!this.saveName || this.saveName < 0) {
        this.saveName = undefined
      }
      this.searchSaveCnt()
    },
    onBlurAddress: function () {
      if (!this.deliAddress || this.deliAddress < 0) {
        this.deliAddress = undefined
      }
      this.searchSaveCnt()
    },
    onBlurSelectedDateStart: function () {
      if (!this.dateStart || this.dateStart < 0) {
        this.dateStart = undefined
      }
      this.searchSaveCnt()
    },
    onBlurSelectedDateEnd: function () {
      if (!this.dateEnd || this.dateEnd < 0) {
        this.dateEnd = undefined
      }
      this.searchSaveCnt()
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    selectedAll: function (event) {
      event.target.select()
    },
    selectedDateStart: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      this.dateStart = format
      this.searchSaveCnt()
    },
    selectedDateEnd: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      this.dateEnd = format
      this.searchSaveCnt()
    },
    clearedDateStart: function () {
      this.dateStart = undefined
      this.searchSaveCnt()
    },
    clearedDateEnd: function () {
      this.dateEnd = undefined
      this.searchSaveCnt()
    },
    searchSaveCnt: function () {
      let payload = {
        saveName: this.saveName,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        deliAddress: this.deliAddress
      }
      axios.post(DC_URL.SAVE + '/save-product-cnt', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.productCnt = response.data.data
          }
        }).catch(error => {
          Api.handleError(error)
          this.modalShown = false
        }).finally(() => {
        })
    },
    formatDate: function (date) {
      if (!date) return ''
      let strDate = moment(date).format('YYYY-MM-DD')
      return strDate
    }
  }, // end method
  mounted: function () {
  },
  created: function () {
    let params = App.getLocalStorage(DC_STORAGE_KEY.SAVE_PRODUCT_SEARCH)
    if (params && Object.keys(params).length > 0) {
      this.saveName = params.saveName
      this.dateStart = params.dateStart
      this.dateEnd = params.dateEnd
      this.deliAddress = params.deliAddress
    }
  }
}
</script>
<style src="../../../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/search/DcSaveProductSearchModal.vue